// @ts-check

import axios from 'axios';
import { AxiosPromise } from 'axios';

class TileServerClient {

    /**
     * @param {String} tileServerUrl url to tile server (from .env)
     */

    constructor(tileServerUrl) {

        this.tileServerUrl = tileServerUrl;
        this.datesUrl = this.tileServerUrl + '/dates.json';
        // this.wetlandsDataUrl = this.tileServerUrl + '/wetlands-data.json';
        this.wetlandsStatsUrl = this.tileServerUrl;
        this.wetlandsGeojsonUrl = this.tileServerUrl + '/wetlands_web.geojson';

        this.polarizations = [
            {
                name : 'VV',
                value : 'VV'
            },
            {
                name : 'VH',
                value : 'VH'
            }
        ];
    }

    /**
     * 
     * Generates tile source url for date and polarization
     * 
     * @param {String} date "yyyy-mm" format
     * @param {String} polarization "VV" or "VH"
     * 
     * @returns {String} url string to be used with openlayers XYZ source
     */
    getTileSourceUrl(date, polarization) {

        let url = '';

        if(date && polarization)
            url = `${this.tileServerUrl}/${date}/${polarization}/{z}/{x}/{y}.png`

        return url;
    }

    /**
     * Get wetlands geojson from tileserver
     * 
     * @returns {AxiosPromise}
     */
    getWetlandsGeojson() {
        return axios.get(this.wetlandsGeojsonUrl);
    }

    /**
     * Get available dates from tileserver
     * 
     * @returns {AxiosPromise}
     */
    getDates() {
        return axios.get(this.datesUrl);
    }

    // /**
    //  * Get json with dates and stats data from tileserver
    //  * 
    //  * @returns {AxiosPromise}
    //  */
    // getWetlandsStats() {
    //     return axios.get(this.wetlandsDataUrl);
    // }

    /**
     * Get json with dates and stats data from tileserver
     * 
     * @returns {AxiosPromise}
     */
    getWetlandsStats(dateString) {

        let url = `${this.wetlandsStatsUrl}/${dateString}/wetlands-stats.json`;

        return axios.get(url);
    }

}
export default TileServerClient;
